export default __webpack_public_path__ + "images/f5e529434c75536084cc0518cc43250b-3_4K_1920x544.webp";